// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c38b4af0","667":"b2b806f4","977":"b4afc4ed"}[chunkId] + ".chunk.js";
};